<div class="logo-container">
  <img src="images/logos/SCi-Logo-White.png" alt="Shotcrete intelligence logo" width="166" />
</div>
<menu class="sidebar-container">
  <app-project-selector></app-project-selector>
  <a
    variant="link"
    routerLink="/project-tracker"
    color="neutral"
    class="sidebar-solo-link"
  >
    <mat-icon class="title-icon" svgIcon="table"></mat-icon>
    <span class="title">{{ 'layout.left.projectTracker' | translate }}</span>
  </a>
  <mat-accordion>
    <!-- Admin panel -->
    @if (findPermission('admin', 'menu')) {
      <mat-expansion-panel #adminPanel class="sidebar-expansion-panel">
        <mat-expansion-panel-header
          class="sidebar-expansion-panel-header"
          [class.expansion-panel__active]="adminPanel.expanded"
        >
          <mat-panel-title>
            <mat-icon class="title-icon" svgIcon="settingsAccountBox"></mat-icon>
            <span class="title">{{ 'layout.left.admin.title' | translate }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="sidebar-links">
          @if (findPermission('admin', 'users')) {
            <a
              variant="link"
              routerLink="/admin/users"
              color="neutral"
              class="sidebar-link"
            >
              {{ 'layout.left.admin.users' | translate }}
            </a>
          }
          @if (findPermission('admin', 'projects')) {
            <a
              variant="link"
              routerLink="/admin/projects"
              color="neutral"
              class="sidebar-link"
            >
              {{ 'layout.left.admin.projects' | translate }}
            </a>
          }
          @if (findPermission('admin', 'apiKeys')) {
            <a
              variant="link"
              routerLink="/admin/api-keys"
              color="neutral"
              class="sidebar-link"
            >
              {{ 'layout.left.admin.apiKeys' | translate }}
            </a>
          }
          @if (findPermission('admin', 'newBulkCut')) {
            <a
              variant="link"
              routerLink="/admin/new-bulk-cut"
              color="neutral"
              class="sidebar-link"
            >
              {{ 'layout.left.cuts.newBulkCutView' | translate }}
            </a>
          }
          @if (findPermission('admin', 'viewBulkCut')) {
            <a
              variant="link"
              routerLink="/admin/bulk-cut"
              color="neutral"
              class="sidebar-link"
            >
              {{ 'layout.left.cuts.bulkCutsView' | translate }}
            </a>
          }
          @if (findPermission('admin', 'roles')) {
            <a
              variant="link"
              routerLink="/admin/roles"
              color="neutral"
              class="sidebar-link"
            >
              {{ 'layout.left.admin.roles' | translate }}
            </a>
          }
        </div>
      </mat-expansion-panel>
    }
    <!-- Project admin panel -->
    @if (findPermission('projectAdmin', 'menu')) {
      <mat-expansion-panel #projectAdminPanel class="sidebar-expansion-panel">
        <mat-expansion-panel-header
          class="sidebar-expansion-panel-header"
          [class.expansion-panel__active]="projectAdminPanel.expanded"
        >
          <mat-panel-title>
            <mat-icon class="title-icon">settings</mat-icon>
            <span class="title">{{ 'layout.left.projectAdmin.title' | translate }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="sidebar-links">
          @if (findPermission('projectAdmin', 'crew')) {
            <a
              variant="link"
              routerLink="/project-admin/crew"
              color="neutral"
              class="sidebar-link"
            >
              {{ 'layout.left.projectAdmin.crew' | translate }}
            </a>
          }
          @if (findPermission('projectAdmin', 'settings')) {
            <a
              variant="link"
              routerLink="/project-admin/settings"
              color="neutral"
              class="sidebar-link"
            >
              {{ 'layout.left.projectAdmin.settings' | translate }}
            </a>
          }
          @if (findPermission('projectAdmin', 'activityLog')) {
            <a
              variant="link"
              routerLink="/project-admin/activity-log"
              color="neutral"
              class="sidebar-link"
            >
              {{ 'layout.left.projectAdmin.activityLog' | translate }}
            </a>
          }
          @if (findPermission('projectAdmin', 'fileManager')) {
            <a
              variant="link"
              routerLink="/project-admin/file-manager"
              color="neutral"
              class="sidebar-link"
            >
              {{ 'layout.left.projectAdmin.fileManager' | translate }}
            </a>
          }
        </div>
      </mat-expansion-panel>
    }
    <!-- Cuts panel -->
    @if (findPermission('cuts', 'menu')) {
      <mat-expansion-panel #cutsPanel class="sidebar-expansion-panel">
        <mat-expansion-panel-header
          class="sidebar-expansion-panel-header"
          [class.expansion-panel__active]="cutsPanel.expanded"
        >
          <mat-panel-title>
            <mat-icon class="title-icon" svgIcon="cuts"></mat-icon>
            <span class="title">{{ 'layout.left.cuts.title' | translate }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="sidebar-links">

          @if (findPermission('cuts', 'viewCuts')) {
            <a
              variant="link"
              routerLink="/cuts/view"
              color="neutral"
              class="sidebar-link"
            >
              {{ 'layout.left.cuts.view' | translate }}
            </a>
          }
          @if (findPermission('cuts', 'viewOnlineCuts')) {
            <a
              variant="link"
              routerLink="/cuts/view-online"
              color="neutral"
              class="sidebar-link"
            >
              {{ 'layout.left.cuts.onlineView' | translate }}
            </a>
          }
          @if (findPermission('cuts', 'newCut')) {
            <a
              variant="link"
              routerLink="/cuts/new"
              color="neutral"
              class="sidebar-link"
            >
              {{ 'layout.left.cuts.new' | translate }}
            </a>
          }
        </div>
      </mat-expansion-panel>
    }
    <!-- Reports panel -->
    @if (findPermission('reports', 'menu')) {
      <mat-expansion-panel #reportsPanel class="sidebar-expansion-panel">
        <mat-expansion-panel-header
          class="sidebar-expansion-panel-header"
          [class.expansion-panel__active]="reportsPanel.expanded"
        >
          <mat-panel-title>
            <mat-icon class="title-icon" svgIcon="analytics"></mat-icon>
            <span class="title">{{ 'layout.left.reports.title' | translate }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="sidebar-links">
          @if (findPermission('reports', 'mainDashboard')) {
            <a
              variant="link"
              routerLink="/reports/main-dashboard"
              color="neutral"
              class="sidebar-link"
            >
              {{ 'layout.left.reports.dashboard' | translate }}
            </a>
          }
          @if (findPermission('reports', 'applicationOverview')) {
            <a
              variant="link"
              routerLink="/reports/application-overview"
              color="neutral"
              class="sidebar-link"
            >
              {{ 'layout.left.reports.applicationOverview' | translate }}
            </a>
          }
          @if (findPermission('reports', 'progressOverview')) {
            <a
              variant="link"
              routerLink="/reports/progress-overview"
              color="neutral"
              class="sidebar-link"
            >
              {{ 'layout.left.reports.progressOverview' | translate }}
            </a>
          }
          @if (findPermission('reports', 'shotcreteOverview')) {
            <a
              variant="link"
              routerLink="/reports/shotcrete-overview"
              color="neutral"
              class="sidebar-link"
            >
              {{ 'layout.left.reports.shotcreteOverview' | translate }}
            </a>
          }
          @if (findPermission('reports', 'sprayerPerformance')) {
            <a
              variant="link"
              routerLink="/reports/sprayer-performance"
              color="neutral"
              class="sidebar-link"
            >
              {{ 'layout.left.reports.sprayerPerformance' | translate }}
            </a>
          }
          @if (findPermission('reports', 'cutSummary')) {
            <a
              variant="link"
              routerLink="/reports/cut-summary"
              color="neutral"
              class="sidebar-link"
            >
              {{ 'layout.left.reports.cutSummary' | translate }}
            </a>
          }
        </div>
      </mat-expansion-panel>
    }
  </mat-accordion>
  <a
    variant="link"
    routerLink="/support"
    color="neutral"
    class="sidebar-solo-link"
  >
    <mat-icon class="title-icon">help_center</mat-icon>
    <span class="title">{{ 'layout.left.support' | translate }}</span>
  </a>
</menu>
